export { default as WorkSpecificationSlot } from './WorkSpecificationSlot';
